import RichTextInput from "ra-input-rich-text";
import React from "react";
import { ArrayInput, BooleanInput, Create, FormTab, SimpleFormIterator, TabbedForm, TextInput } from "react-admin";
import { videoIdExtractorTransform } from "../../utils/video-id-extractor-transform";
import { VideoUrlInput } from "../../components/video-url-input";

const GuidelineTypeCreate = (props) =>
    <Create {...props} transform={videoIdExtractorTransform}>
        <TabbedForm redirect={'list'}>
            <FormTab label={'Dados Gerais'} >
                <TextInput source="name" label={'Nome'} fullWidth />
                <BooleanInput source="public" label={'Pública?'} fullWidth />
                <RichTextInput source='details' label='Orientações' />
                <ArrayInput source="links" label="Vídeos" variant="standard">
                    <SimpleFormIterator>
                        <TextInput source="title" label="Título" fullWidth />
                        <VideoUrlInput source="url" label="URL" fullWidth />
                    </SimpleFormIterator>
                </ArrayInput>
            </FormTab>
        </TabbedForm>
    </Create >

export default GuidelineTypeCreate;